import React from "react";

import SiteHeader from "./SiteHeader";


export default function PublicPageLayout({
  eyebrow,
  title,
  intro,
  children,
}) {
  return (
    <main className="public-page">

      <style>
        {styles}
      </style>


      <SiteHeader />


      <section className="public-hero">

        <div className="public-hero-inner">

          {eyebrow && (
            <span className="public-eyebrow">
              {eyebrow}
            </span>
          )}

          <h1>
            {title}
          </h1>

          <p>
            {intro}
          </p>

        </div>

      </section>


      <section className="public-content">

        <div className="public-content-inner">
          {children}
        </div>

      </section>

    </main>
  );
}


const styles = `

.public-page {
  min-height: 100vh;

  background: #fff;

  color: #17212b;

  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "SF Pro Display",
    "SF Pro Text",
    "PingFang TC",
    "Microsoft JhengHei",
    Arial,
    sans-serif;
}


.public-page * {
  box-sizing:
    border-box;
}


/* ======================================================
   Hero
   ==================================================== */

.public-hero {
  border-bottom:
    1px solid #edf0f2;

  background:
    linear-gradient(
      135deg,
      #fff8ee 0%,
      #fff 74%
    );
}


.public-hero-inner {
  width:
    min(
      1180px,
      calc(100% - 48px)
    );

  margin:
    0 auto;

  padding:
    88px 0 76px;
}


.public-eyebrow {
  display: block;

  margin-bottom:
    14px;

  color:
    #e87820;

  font-size:
    11px;

  font-weight:
    850;

  letter-spacing:
    0.16em;
}


.public-hero h1 {
  max-width:
    760px;

  margin: 0;

  color:
    #17212b;

  font-size:
    clamp(
      36px,
      5vw,
      62px
    );

  line-height:
    1.12;

  letter-spacing:
    -0.06em;

  font-weight:
    900;
}


.public-hero p {
  max-width:
    650px;

  margin:
    20px 0 0;

  color:
    #78848c;

  font-size:
    15px;

  line-height:
    1.85;
}


/* ======================================================
   Content
   ==================================================== */

.public-content {
  background:
    #fff;
}


.public-content-inner {
  width:
    min(
      1040px,
      calc(100% - 48px)
    );

  padding:
    42px 0 74px;

  margin:
    0 auto;
}


/* ======================================================
   Grid
   ==================================================== */

.public-page-grid {
  display: grid;

  grid-template-columns:
    repeat(
      3,
      minmax(0, 1fr)
    );

  gap:
    16px;
}


.public-page-card {
  min-height:
    170px;

  padding:
    24px;

  border:
    1px solid #e8edf0;

  border-radius:
    16px;

  background:
    #fff;

  box-shadow:
    0 6px 18px
    rgba(
      22,
      37,
      48,
      0.035
    );
}


.public-page-card h2 {
  margin: 0;

  color:
    #24313a;

  font-size:
    18px;

  letter-spacing:
    -0.025em;
}


.public-page-card p {
  margin:
    12px 0 0;

  color:
    #78848c;

  font-size:
    13px;

  line-height:
    1.8;
}


/* ======================================================
   List
   ==================================================== */

.public-page-list {
  display: grid;

  gap: 0;

  border-top:
    1px solid #e8edf0;
}


.public-page-row {
  display: grid;

  grid-template-columns:
    240px minmax(0, 1fr);

  gap:
    26px;

  padding:
    23px 0;

  border-bottom:
    1px solid #e8edf0;
}


.public-page-row h2 {
  margin: 0;

  color:
    #24313a;

  font-size:
    18px;

  letter-spacing:
    -0.02em;
}


.public-page-row p {
  margin: 0;

  color:
    #78848c;

  font-size:
    14px;

  line-height:
    1.8;
}


/* ======================================================
   CTA
   ==================================================== */

.public-page-cta {
  min-height:
    44px;

  display:
    inline-flex;

  align-items:
    center;

  justify-content:
    center;

  margin-top:
    30px;

  padding:
    0 18px;

  color:
    #fff;

  background:
    #17212b;

  border-radius:
    10px;

  font-size:
    13px;

  font-weight:
    800;

  text-decoration:
    none;
}


/* ======================================================
   Tablet
   ==================================================== */

@media (
  max-width: 920px
) {

  .public-page-grid {
    grid-template-columns:
      1fr 1fr;
  }

}


/* ======================================================
   Mobile
   ==================================================== */

@media (
  max-width: 640px
) {

  .public-hero-inner,
  .public-content-inner {
    width:
      calc(
        100% - 36px
      );
  }


  .public-hero-inner {
    padding:
      64px 0 54px;
  }


  .public-hero h1 {
    font-size:
      39px;
  }


  .public-hero p {
    font-size:
      14px;
  }


  .public-page-grid {
    grid-template-columns:
      1fr;
  }


  .public-page-card {
    min-height:
      0;
  }


  .public-page-row {
    grid-template-columns:
      1fr;

    gap:
      8px;
  }


  .public-page-row p {
    font-size:
      13px;
  }

}

`;